import forEach from '../../../../javascripts/dom/forEach';

const accordions = document.querySelectorAll('[data-js-module="m-accordion"]');

const init = async () => {
  const { default: Accordion } = await import(/* webpackChunkName: "m-accordion" */ './accordion');
  forEach(accordions, (index, element) => new Accordion(element));
};

if (accordions.length) init();
